import { lazy } from "react";

const MyRequestsPage = lazy(() =>
  import("@/pages/vendor/my-requests").then((m) => ({
    default: m.MyRequestsPage,
  })),
);
const TicketDetailPage = lazy(() =>
  import("@/pages/vendor/my-requests").then((m) => ({
    default: m.TicketDetailPage,
  })),
);

// No RouteGuard — like help-support, every store member can
// see their own support requests; there's no resource:action gate for it.
const MyRequestsRoutes = {
  path: "my-requests",
  children: [
    { path: "", element: <MyRequestsPage /> },
    { path: ":ticketId", element: <TicketDetailPage /> },
  ],
};

export default MyRequestsRoutes;
